import { Injectable, Renderer2, ElementRef } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  public renderer: Renderer2;
  public elementRef: ElementRef;

  constructor() { }
  public setElementRef(el) {
    this.elementRef = el;
  }

  public hideLoadingSpinner(): void {
    this.renderer.setStyle(
      this.elementRef.nativeElement.querySelector('.bil-loading-screen'),
      'z-index',
      -1
    );
  }

  public showLoadingSpinner(): void {
    this.renderer.setStyle(
      this.elementRef.nativeElement.querySelector('.bil-loading-screen'),
      'visibility',
      'visible'
    );
    this.renderer.setStyle(
      this.elementRef.nativeElement.querySelector('.bil-loading-screen'),
      'z-index',
      999999
    );
  }
}
